import { parseDateOnlyLocal } from './dateOnly';
// Progress bar color utility
// 0% = red, 1-99% = yellow transitioning to green, 100% = green

export const getProgressColorClass = (progress: number): string => {
  if (progress === 0) return 'bg-red-500';
  if (progress === 100) return 'bg-emerald-500';
  // 1-99%: transition from amber/yellow to lime/green
  if (progress < 30) return 'bg-amber-500';
  if (progress < 60) return 'bg-yellow-500';
  if (progress < 80) return 'bg-lime-500';
  return 'bg-green-500';
};

export const getProgressIndicatorStyle = (progress: number): string => {
  if (progress === 0) return '[&>div]:bg-red-500';
  if (progress === 100) return '[&>div]:bg-emerald-500';
  if (progress < 30) return '[&>div]:bg-amber-500';
  if (progress < 60) return '[&>div]:bg-yellow-500';
  if (progress < 80) return '[&>div]:bg-lime-500';
  return '[&>div]:bg-green-500';
};

// Deadline status utility
// Returns status based on how close the end date is
export type DeadlineStatus = 'overdue' | 'warning' | 'normal' | null;

export const getDeadlineStatus = (dataFim: string | undefined): DeadlineStatus => {
  if (!dataFim) return null;

  const today = new Date();
  today.setHours(0, 0, 0, 0);

  const endDate = parseDateOnlyLocal(dataFim);
  if (!endDate) return null;

  const diffDays = Math.ceil((endDate.getTime() - today.getTime()) / (1000 * 60 * 60 * 24));

  if (diffDays < 0) return 'overdue'; // Vencido
  if (diffDays <= 7) return 'warning'; // Vence em até 7 dias
  return 'normal';
};

export const getDeadlineBadgeStyle = (status: DeadlineStatus): string => {
  switch (status) {
    case 'overdue':
      return 'bg-red-100 text-red-700 border-red-300 dark:bg-red-900/30 dark:text-red-400 dark:border-red-700';
    case 'warning':
      return 'bg-amber-100 text-amber-700 border-amber-300 dark:bg-amber-900/30 dark:text-amber-400 dark:border-amber-700';
    default:
      return '';
  }
};
